import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import ProblemSection from "@/components/landing/ProblemSection";
import SolutionSection from "@/components/landing/SolutionSection";
import BeforeAfter from "@/components/landing/BeforeAfter";
import NicheCallout from "@/components/landing/NicheCallout";
import Testimonials from "@/components/landing/Testimonials";
import Process from "@/components/landing/Process";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import MobileCallBar from "@/components/landing/MobileCallBar";

function App() {
  return (
    <div className="App font-sans text-white antialiased bg-nav-950">
      <Toaster richColors theme="dark" position="top-center" />
      <Header />
      <main data-testid="main-content">
        <Hero />
        <TrustBar />
        <ProblemSection />
        <SolutionSection />
        <BeforeAfter />
        <NicheCallout />
        <Testimonials />
        <Process />
        <Pricing />
        <FAQ />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <MobileCallBar />
    </div>
  );
}

export default App;
